import GeneralDialog from '../../../shared/general-dialog';
import { SignatureModel } from '../../../../types';
import SharedSignatureTemplateGridLogs from './shared-signature-template-grid-logs';

interface SignatureTemplateRunLogsProps {
  open: boolean;
  handleClose: () => void;
  selectedSignatureTemplate: SignatureModel;
}

export default function SignatureTemplateRunLogs({
  open,
  handleClose,
  selectedSignatureTemplate,
}: SignatureTemplateRunLogsProps) {
  const signatureId = selectedSignatureTemplate.id;

  return (
    <GeneralDialog
      open={open}
      maxWidth="lg"
      handleClose={handleClose}
      title={`Signature Template "${selectedSignatureTemplate.templateName}" Run Logs`}
      dialogContent={
        <SharedSignatureTemplateGridLogs signatureId={signatureId} />
      }
    />
  );
}
